import { Inject, Injectable, Injector } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class IntraOne_ReportService {

  constructor(
    private injector: Injector
  ) {
  }

  public IntraOne: IntraOne_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

